/* ==========================================================================
   SITE — everything that isn't a project: your name and the bio on the
   home page. Edit freely; the header and home page read from here.
   ========================================================================== */

import cv from "../assets/CV.pdf";

const site = {
  /** Shown top-left on every page and in the browser tab. */
  name: "Charles Ingea",

  /** Short bio shown above the project table on the home page.
   *  One string per paragraph.
   *  `data-cursor-icon` on a link shows a little pixel icon beside the
   *  mouse pointer when hovering it: "mail", "link" or "document"
   *  (drawn in components/PixelIcon.js). Works on any link on the site. */
  bio: [
    "Charles Ingea is an interdisciplinary designer, researcher and technologist based between London and Beirut.",
    "He uses traditional media and emerging technologies to investigate spatial conditions and experiment with new forms of knowledge representation",
    <>
    <em>
    <a href="mailto:charlesingea@gmail.com" className="ext-link" data-cursor-icon="mail">
      Send me an email
    </a>, <a href="https://www.linkedin.com/in/charles-ingea/" target="_blank" rel="noreferrer" className="ext-link" data-cursor-icon="link">
      find me on LinkedIn
    </a>, <a href={cv} target="_blank" rel="noreferrer" className="ext-link" data-cursor-icon="document">
      download my CV
    </a>, or scroll down to see my work.
    </em>
    </>
  ],
};

export default site;
